import { number } from 'echarts';
import city from './city.json'
import { max } from 'moment';
export const tableOption = (value) => {
  let that = value;
  return {
    dialogDrag: true,
     border: true,
    indexLabel: "序号",
    // stripe: true,
    menuAlign: "center",
    align: "left",
    menuType: "text",
    searchShow: true,
    excelBtn: false,
    printBtn: false,
    dialogWidth: "66%",
    dialogFullscreen:true,
    delBtn: false,
    viewBtn: false,
    addBtn:false,
    editBtn: false,
    emptyBtn:false,
    searchSubBtn:false,
    searchBtn:false,
    submitIcon:" ",
    submitText:"保存",
    queryBtn:false,
    dialogClickModal: false,
    searchMenuSpan: 6,
    labelWidth: 120,
    searchLabelWidth: 100,
    menuWidth: 240,
    span:13,
    customClass: "customProjectDialog",
    // searchIcon:true,
    // searchIndex:3,
    // searchCustom:2,
    routerName:"projectinfo2",
    group: [
      //弹窗区分
      {
        label: "基本信息",
        arrow: false,
        prop: "group1",
        column: [
          {
            label: "项目名称",
            prop: "projectName",
            placeholder: "请输入名称，建议45字以内",
            maxlength: 45,
            showWordLimit:true,
            order: 1,
            rules: [
              {
                required: true,
                message: "请输入项目名称",
                trigger: "blur",
              },
              {
                max: 45,
                message: "长度在不能超过45个字符",
              },
            ],
          },
          // {
          //   label: '所在城市',
          //   prop: 'city',
          //   type: "cascader",
          //   order: 2,
          //   sortable: true,
          //   placeholder:"请选择",
          //   dicData: city,
          //   props: {
          //     label: 'name',
          //     value: 'name'
          //   },
          //   rules: [
          //     {
          //       required: true,
          //       message: '请选择所在城市',
          //       trigger: 'change'
          //     },
          //   ],
          //   minWidth: 160,
          //   overHidden: true,
          //   change: (val) => {
          //     if (val.value.length > 0) {
          //       that.searchOption = {
          //         citylimit: true,
          //         city: val.value[val.value.length - 1]
          //       }
          //     } else {
          //       that.searchOption = {
          //         citylimit: false,
          //       }
          //     }
    
          //   }
          // },
          {
            label: "详细地址",
            prop: "projectAddress",
            placeholder: "请输入详细地址",
            sortable: false,
            maxlength: 30,
            showWordLimit: true,
            order: 2,
            formslot: true,
            rules: [
              {
                required: true,
                message: "请输入详细地址",
                trigger: "blur",
              },
              {
                max: 30,
                message: "长度在不能超过30个字符",
              },
            ],
          },
          {
            label: "范围(米)",
            prop: "electronicRange",
            order: 2,
            rules: [
              {
                required: true,
                message: "请输入电子围栏（米）",
                trigger: "blur",
              },
            ],
          },
          
        
          {
            label: "项目负责人",
            prop: "leadingIds",
            order: 2,
            type: "select",
            props: {
              label: "name",
              value: "id",
            },
            multiple: true,
            dicUrl: "/chain/companystaff/list",
            // search: true,
            formslot: true, // 自定义表单
            filterable: true,
            rules: [
              {
                required: true,
                message: "请选择负责人",
                trigger: "change",
              },
            ],
          },
          {
            label: "项目成员",
            prop: "memberIds",
            order: 3,
            type: "select",
            props: {
              label: "name",
              value: "id",
            },
            multiple: true,
            filterable: true,
            dicUrl: "/chain/companystaff/list2",
               rules: [
              {
                required: true,
                message: "请选择项目成员",
                trigger: "change",
              },
            ],
          },
          {
            label: "结算类型",
            prop: "settleType",
            type: "select",
            order: 4,
            value: "1",
            props: {
              label: "itemName",
              value: "itemValue",
            },
            dicUrl:
              "/chain/systemdictionaryitem/listDictionaryItem?dictionary=settle_type",
            change: ({ value }) => {
              if (value) {
                let group = that.tableOption.group.find(
                  (item) => item.prop == "group3"
                );
                group.display = value == 4;
              }
            },
            rules: [
              {
                required: true,
                message: "请选择运单结算类型",
                trigger: "change",
              },
            ],
          },
          {
            label: "土质",
            prop: "listSoilType",
            order: 5,
            sortable: true,
            type: "select",
            filterable: true,
            props: {
              label: "itemName",
              value: "itemName",
            },
            multiple: true,
            separator: ",",
            dicUrl:
              "/chain/systemdictionaryitem/listDictionaryItem?dictionary=soil_type",
          },
          {
            label: "泥尾",
            prop: "garbageIds",
            order: 6,
            type: "select",
            filterable: true,
            props: {
              label: "names",
              value: "id",
            },
            multiple: true,
            dicUrl: "/chain/garbage/listByCompanyAuth",
          },
        ],
      },
      {
        label: "电子卡签单及APP直付设置",
        arrow: false,
        prop: "group3",
        className: "group3",
        display: false,
        class: "group3",
        column: [
          {
            label: "",
            labelWidth: 0,
            span: 24,
            prop: "annotation",
          },
          {
            label: "项目钱包余额停止直付(元)",
            labelWidth: 200,
            prop: "stopPayBalance",
            type: "number",
            controls: false,
            minRows: 0,
            maxRows: 999999999.99,
            precision: 2,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
            span: 16,
          },
          {
            label: "项目钱包余额短信通知(元)",
            labelWidth: 200,
            prop: "smsBalance",
            type: "number",
            controls: false,
            minRows: 0,
            maxRows: 999999999.99,
            precision: 2,
            // row:true,
            span: 16,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "司机运单卸土之后提现限制(小时)",
            labelWidth: 240,
            row: true,
            span: 16,
            prop: "companyWithdrawPeriod",
            type: "number",
            controls: false,
            minRows: 0,
            maxRows: 999999999,
            precision: 0,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "直付通道",
            prop: "directChannel",
            value: "1",
            type: "radio",
            dicData: [
              {
                label: "快钱支付",
                value: "1",
              },
              {
                label: "平安银行支付",
                value: "2",
              },
              {
                label: "台州银行支付",
                value: "5",
              },
            ],
            span: 24,
          },
          {
            label: "",
            span: 24,
            prop: "smsNoticeMobile",
            labelWidth: 8,
          },
          {
            label: "出场签单价格为直付价",
            prop: "isGoPayDirect",
            labelWidth: 160,
            value: "0",
            change: ({ value }) => {
              if (value) {
                console.log(that.tableOption);
                let maxDirectPay = that.tableOption.group.find(
                  (item) => item.prop == "group3"
                ).column.find(item2=>item2.prop=='maxDirectPay')
                maxDirectPay.display = value == 1;
                // that.form.weightType = value == 1?"3":"1"
                // that.form.isCubicPrice = value == 1?"1":"0"
              }
            },
            type: "switch",
            dicData: [
              {
                label: "否",
                value: "0",
              },
              {
                label: "是",
                value: "1",
              },
            ],
            span: 24,
          },
          {
            label: "最高限额价(元)",
            prop: "maxDirectPay",
            value: 1500,
            type:'number',
            controls:false,
            display:false,
            precision:2,
            minRows:0,
            maxRows:99999,
            span: 12,
          },
          {
            label: "直付触发点",
            prop: "directTriggerPoint",
            value: "1",
            type: "radio",
            dicData: [
              {
                label: "司机卸土",
                value: "0",
              },
              {
                label: "司机出场",
                value: "1",
              },
            ],
            span: 24,
          },
        ],
        span: 12,
      },
      {
        label: "签单设置",
        arrow: false,
        prop: "group2",
        span: 12,
        column: [
          {
            label: "出场签单",
            prop: "isGo",
            order: 1,
            span: 24,
          },
          {
            label: "车队名称必填可选",
            prop: "fleetNameModelRequire",
            className:"custom-label",
            value: "0",
            type: "radio",
            order: 2,
            dicData: [
              {
                label: "必填",
                value: "1",
              },
              {
                label: "非必填",
                value: "0",
              },
            ],
          },
          {
            label: "车队名称填写",
            prop: "fleetNameModelType",
            order: 2,
          },
          {
            label: "可选历史签单车牌",
            prop: "truckCodePeriod",
            placeholder: "请输入",
            className:"custom-label",
            append:"天内",
            type: "number",
            controls: false,
            row: true,
            span: 13,
            order: 2,
            precision: 0,
            minRows: 0,
            hide: true,
            showCloumn: false,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
        {
          label: "同车牌签单间隔",
          prop: "goInterval",
          placeholder: "请输入",
          className:"custom-label",
          type: "number",
          controls: false,
          row: true,
          span: 13,
          order: 2,
          precision: 0,
          minRows: 0,
          hide: true,
          showCloumn: false,
          rules: [
            {
              required: true,
              message: "请输入",
              trigger: "blur",
            },
          ],
        },
        {
          label: "修改运单审核",
          prop: "overtimePeriod",
          placeholder: "请输入",
          type: "number",
          controls: false,
          row: true,
          span: 13,
          width: 280,
          order: 2,
          precision: 0,
          minRows: 0,
          hide: true,
          showCloumn: false,
          rules: [
            {
              required: true,
              message: "请输入",
              trigger: "blur",
            },
          ],
        },
        {
          label: "出场图片离线上传",
          prop: "isGoPictureUploadOffline",
          type: "checkbox",
          className:"custom-label",
          value: "0",
          dicData: [
            {
              label: "否",
              value: "0",
            },
            {
              label: "是",
              value: "1",
            },
          ],
          order: 2,
          span: 24,
        },
        {
          label: "信息核对",
          prop: "goWaybillTipCheck",
          type: "switch",
          value: "0",
          dicData: [
            {
              label: "否",
              value: "0",
            },
            {
              label: "是",
              value: "1",
            },
          ],
          order: 2,
          span: 24,
        },
          {
            label: "入场签单",
            prop: "isEntranceWaybill",
            order: 2,
            span: 24,
          },
         
          {
            label: "挖机签单",
            prop: "isIn",
            order: 3,
            span: 24,
          },
          {
            label: "挖机图片离线上传",
            prop: "isInPictureUploadOffline",
            className:"custom-label",
            value: "0",
            type: "switch",
            dicData: [
              {
                label: "否",
                value: "0",
              },
              {
                label: "是",
                value: "1",
              },
            ],
            order: 3,
            span: 24,
          },
          
          {
            label: "可选历史挖机签单",
            prop: "inWaybillSaveTime",
            placeholder: "请输入",
            type: "number",
            controls: false,
            span: 13,
            width: 280,
            order: 5,
            precision: 0,
            minRows: 15,
            maxRows: 99999,
            hide: true,
            showCloumn: false,
            className:"custom-label",
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "",
            prop: "remark1",
            labelWidth: 0,
            detail:true,
            placeholder: " ",
            className:"tip-desc",
            value:"最小15分钟内",
            span: 11,
            width: 0,
            order: 5,
            hide: true,
            showCloumn: false,
          },
          {
            label: "台班作业类型",
            prop: "manHourType",
            order: 6,
            span: 24,
          },
          {
            label: "台班作业地点",
            prop: "inJobAddress",
            order: 7,
            span: 24,
          },
          {
            label: "台班工时单位",
            prop: "inUnitWork",
            order: 8,
            span: 24,
          },
          
          // {
          //   label: "强制下班时长(小时)",
          //   prop: "test",
          //   labelWidth: 264,
          //   placeholder: "请输入",
          //   type: "number",
          //   controls: false,
          //   row: true,
          //   span: 13,
          //   width: 280,
          //   order: 5,
          //   precision: 0,
          //   minRows: 0,
          //   hide: true,
          //   showCloumn: false,
          //   rules: [
          //     {
          //       required: true,
          //       message: "请输入",
          //       trigger: "blur",
          //     },
          //   ],
          // },
       
          // {
          //   label: "出口签单车型",
          //   labelWidth: 180,
          //   prop: "isGoVehicleType",
          //   type: "switch",
          //   value: "0",
          //   dicData: [
          //     {
          //       label: "否",
          //       value: "0",
          //     },
          //     {
          //       label: "是",
          //       value: "1",
          //     },
          //   ],
          //   order: 6,
          //   span: 24,
          // },
          
        ],
      },
      // {
      //   label: "挖机设置",
      //   arrow: false,
      //   prop: "group6",
      //   column: [
        
         
        
          // {
          //   label: "挖机型号模式",
          //   prop: "inModelType",
          //   hide:true,
          //   showCloumn:false,
          //   value: ["1"],
          //   // labelWidth: 180,
          //   type: "checkbox",
          //   dicData: [
          //     {
          //       label: "可输入",
          //       value: "1",
          //     },
          //     {
          //       label: "可选择",
          //       value: "2",
          //     },
          //   ],
          //   rules: [
          //     {
          //       required: true,
          //       message: "请选择",
          //       trigger: "change",
          //     },
          //   ],
          //   order: 3,
          //   span: 24,
          // },
          // {
          //   label: "挖机型号",
          //   prop: "inModel",
          //   order: 2,
          //   span: 24,
          // },
         
          
      //   ],
      // },
      {
        label: "班次设置",
        arrow: false,
        prop: "group4",
        column: [
          {
            label: "班次时间",
            prop: "projectShifts",
            order: 1,
            // labelWidth:0,
            class:"project-shift",
            span:24
          },
        ],
      },
      {
        label: "泥尾票设置",
        arrow: false,
        prop: "group5",
        column: [
          {
            label: "泥尾票",
            prop: "isTicket",
            order: 1,
          },
        ],
      },
     
    ],
  };
};
